import { render, staticRenderFns } from "./CardReportPannel.vue?vue&type=template&id=7890b548&scoped=true"
import script from "./CardReportPannel.vue?vue&type=script&lang=js"
export * from "./CardReportPannel.vue?vue&type=script&lang=js"
import style0 from "./CardReportPannel.vue?vue&type=style&index=0&id=7890b548&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7890b548",
  null
  
)

export default component.exports